import React, {createContext} from 'react';
const BKServiceComponent = createContext(null);
export default BKServiceComponent;
